import React from 'react';
import { parseIfJSON,
  replacePlaceholdersWithVariables, getCorrespondingScheme, replacePlaceholdersWithVariablesV2, getNestedValue2
 } from '../../utils/base';

 // eslint-disable-next-line import/no-cycle
 import Container from '../Container';

import { NodeTypeScheme } from '../../types/base';

const ContainerTemplate: React.FC<NodeTypeScheme> = (obj) => {
  const {
    style: stDraft,
    events: eventsDraft,
    active_state: activeStateDraft,
    parentLoading,
    dataLake,
    pageSettings,
    settings,
    styleChunks,
    enableLocalShimmer,
    hash,
  } = obj || {};
    const { repeatable } = settings || {};
  const { source } = repeatable || {};

  if (!source) {
    return (
    <Container {...obj} />
  );
  }

  if (source) {
          const { active_state } = dataLake?.data ? replacePlaceholdersWithVariablesV2({ style: stDraft, events: eventsDraft, active_state: activeStateDraft }, dataLake.data) : { active_state: activeStateDraft };
          
          const replaced = dataLake?.data && typeof source === 'string' &&  /^{{this\..*}}$/.test(source) 
            ? getNestedValue2(dataLake.data, source.slice(7, -2)) // Remove '{{this.' and '}}'
            : replacePlaceholdersWithVariables(source, pageSettings?.variables);
            
          const parseSourceIfExist = parseIfJSON(replaced);

          // TNBEWEB-1992: the variable this repeatable is bound to, so a `this.*` write inside a
          // row can target variableData.<srcVar>.<index>. Only a simple top-level `{{var}}` source
          // gets write-back this ticket; a nested `{{this.*}}` source renders a read-only `this`.
          const isThisSource = typeof source === 'string' && /^{{this\..*}}$/.test(source);
          const srcMatch = !isThisSource && typeof source === 'string'
            // FE-4733: `-` admitted — a qualified template local is `<placement-id>.<name>`.
            ? source.match(/^\s*\{\{\s*([\w.-]+)\s*\}\}\s*$/)
            : null;
          const srcVar = srcMatch ? srcMatch[1] : undefined;

          if (Array.isArray(parseSourceIfExist)) {
            return parseSourceIfExist.map((sourceItem, sourceIndex) => {
              const dynamicProps = {
                dataLake: {
                  data: parseSourceIfExist[sourceIndex],
                  rowPath: srcVar ? `${srcVar}.${sourceIndex}` : undefined,
                },
                parentIndex: sourceIndex,
                styleChunks,
                nestedTable: true,
                parentLoading: active_state === 'loading' || parentLoading,
                enableLocalShimmer,
              };
              return <Container key={`${obj.id}::${sourceIndex}`} {...obj} {...dynamicProps} hash={hash} />;
            });
          }
  }
};

export default ContainerTemplate;